import { Pipe, PipeTransform } from '@angular/core';
import { StepType } from 'src/app/models/api/agentStep.model';

@Pipe({
  name: 'stepTypeToLabel',
  standalone: true,
})
export class StepTypeToLabelPipe implements PipeTransform {
  /**
   * A pipe to convert StepType enum values to user-friendly labels.
   */

  public transform(value?: string): string {
    switch (value) {
      case StepType.userMessageStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.userMessageStep';
      case StepType.messageStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.messageStep';
      case StepType.toolInvocationStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.toolInvocationStep';
      // Tool request/response step types - two variants exist for backward compatibility:
      // - toolInvocationRequestStep/toolInvocationResultStep: Original types for inline activity pipeline
      // - toolRequestStep/toolResponseStep: New types for unified pipe (audit events pipeline)
      case StepType.toolInvocationRequestStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.toolInvocationRequestStep';
      case StepType.toolInvocationResultStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.toolInvocationResultStep';
      case StepType.toolRequestStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.toolRequestStep';
      case StepType.toolResponseStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.toolResponseStep';
      case StepType.ragStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.ragStep';
      case StepType.aiMessageStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.aiMessageStep';
      case StepType.triggerStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.triggerStep';
      case StepType.memoryStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.memoryStep';
      case StepType.agentHandoffRequestStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.agentHandoffRequestStep';
      case StepType.agentHandoffResponseStep:
        return 'aiAgentStepPage.stepDataSidePanelTitle.agentHandoffResponseStep';
      default:
        console.warn(`Unknown StepType value: ${value}`);
        return '';
    }
  }
}
